<template>
	<div class="worker-row" :class="{ hovered: hover }">
		<div class="worker-label">#{{item.id}}</div>
		<div class="item" :style="style"
			@mouseover="hover = true"
			@mouseleave="hover = false" @click="clicked">
			<v-row no-gutters>
				<v-col class="marker start shrink" v-if="!item.startOut"><v-icon>fas fa-plus</v-icon></v-col>
				<v-col class="marker start fade shrink" v-else><v-icon>fas fa-arrow-alt-left</v-icon></v-col>
				<v-col class="mid-line grow"><div></div></v-col>
				<v-col class="marker end shrink" :class="item.status" v-if="!item.endOut">
					<v-icon v-if="item.status  === workerStatus.Offline">fas fa-stop</v-icon>
					<v-icon v-if="item.status  === workerStatus.Unresponsive">fas fa-times</v-icon>
					<v-icon v-if="item.status  === workerStatus.Processing">fa-spin fas fa-spinner</v-icon>
					<v-icon v-if="item.status  === workerStatus.ShutdownReady">far fa-stop</v-icon>
					<v-icon v-if="item.status  === workerStatus.Waiting">fas fa-ellipsis-h</v-icon>
					<v-icon v-if="item.status  === workerStatus.Restarting">fas fa-power-off</v-icon>
					<v-icon v-if="item.status  === workerStatus.RestartingWatcher">fas fa-power-off</v-icon>
					<v-icon v-if="item.status  === workerStatus.Reimaging">fas fa-power-off</v-icon>
				</v-col>
				<v-col class="marker end fade shrink" :class="item.status" v-else>
					<v-icon>fas fa-arrow-alt-right</v-icon>
				</v-col>
			</v-row>
		</div>
		<system-status-job v-for="j in item.jobs" :key="`w-item-${item.id}-job-${j.id}`" :item="j" @click="clicked" />
	</div>
</template>

<script>
import { workerStatus } from "../../enums";
import systemStatusJob from "./system-status-job.vue";

// TODO, worker shutdown request marker (like dq marker)

export default {
	props: {
		item: Object,
	},
	components: {
		systemStatusJob,
	},
	data() {
		return {
			hover: false,
			workerStatus,
		};
	},
	computed: {
		style() {
			return `left: ${this.item.left}%; width: ${this.item.width}%`;
		},
		dqStyle() {
			return this.item.dqLeft ? `left: ${this.item.dqLeft}%` : "";
		},
	},
	methods: {
		clicked(id) {
			this.$emit("click", id);
		},
	},
};
</script>
